<template>
  <div class="flow-basic">
    <div class="flow-basic-content">
      <el-form ref="form" :model="base" :rules="rules" class="demo-form form-reuqire-left" label-position="top">
        <el-form-item :label="$t('i18n.259a76a10f9b49869f0c95801bb877bf')" prop="logo">
          <div class="flow-avatar">
            <!-- 图标 -->
            <div class="flow-avatar-img" :style="{ background: base.logo.color }">
              <i class="iconfont-2" :class="base.logo.name"></i>
            </div>
            <!-- 更改图标 -->
            <el-popover placement="right" width="340" trigger="click" :visible-arrow="false" v-if="isNewFlow">
              <!-- 图标库 -->
              <ul class="flow-icon-wrap-box">
                <li v-for="i in logos" :key="i" @click="base.logo.name = i">
                  <i class="iconfont-2 icon-button" :class="i"></i>
                </li>
              </ul>
              <!-- 色盘 -->
              <div class="flow-icon-colors">
                <div
                  v-for="color in logoBgColors"
                  :key="color"
                  @click="base.logo.color = color"
                  class="flow-icon-block icon-button"
                >
                  <div class="color-block" :style="{ borderColor: base.logo.color === color ? color : '#ffffff' }">
                    <span class="color-block-content" :style="{ background: color }"></span>
                  </div>
                </div>
              </div>
              <el-button type="text" class="margin-left" slot="reference">{{ $t('419') }}</el-button>
            </el-popover>
          </div>
        </el-form-item>
        <!-- 审批名称 -->
        <el-form-item :label="$t('work_rule_5')" prop="name">
          <el-input
            class="input-width"
            maxlength="50"
            show-word-limit
            type="text"
            :placeholder="$t('850')"
            v-model="base.name"
            :disabled="!isNewFlow"
          ></el-input>
        </el-form-item>
        <!-- 说明 -->
        <el-form-item :label="$t('work_rule_9')" prop="signature">
          <el-input
            class="textarea input-width"
            type="textarea"
            v-model="base.remark"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <!-- 分组 -->
        <el-form-item :label="$t('work_rule_4')" prop="group_id">
          <el-select class="input-width" v-model="base.group_id" :placeholder="$t('221')">
            <el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <!-- 可见人员 -->
        <el-form-item :label="$t('i18n.d1a2637fc5074403b39214e95d95add6')" prop="visible">
          <el-select
            class="input-width"
            v-model="base.visible.toAll"
            :placeholder="$t('221')"
            @change="handlerChangePersonType"
            :disabled="!isNewFlow"
          >
            <el-option :label="$t('998')" :value="0" />
            <el-option :label="$t('i18n.bf7a187ce5f04f07a533979d003f764a')" :value="1" />
          </el-select>
          <!-- 部分人员 选择人员 -->
          <div class="flow-select-person" v-if="base.visible.toAll">
            <div>
              <el-tag v-for="per in selected" :key="per.id" class="margin-right">{{ per.name }}</el-tag>
              <span v-show="false">{{
                ((staffLength = base.visible.staff.length), (depLength = base.visible.department.length))
              }}</span>
              <span v-if="selected && selected.length">
                <span v-if="(depLength || staffLength) > 2">{{ $t('bf5ae1f0') }}</span>
                <span v-if="depLength"> {{ $t('5ae1f07b', { x: depLength }) }} </span>
                <span v-if="staffLength">{{ $t('f5ae1f07', { y: staffLength }) }}</span>
              </span>
            </div>
            <el-button type="text" @click="orgVisible = true">{{ $t('635') }}</el-button>
          </div>
        </el-form-item>
        <!-- 发起人撤销 -->
        <el-form-item
          class="is-required"
          :label="$t('work_rule_15')"
          :prop="base.is_allow_cancel === 4 ? 'allow_cancel_days' : 'is_allow_cancel'"
        >
          <el-radio-group v-model="base.is_allow_cancel">
            <!-- 不可撤销 -->
            <el-radio class="radio" :label="0">{{ $t('work_rule_16') }}</el-radio>
            <!-- 未审批之前可撤销（无需审批人同意，撤销原因费必填） -->
            <el-radio class="radio" :label="1">{{ $t('i18n.260c79ca4150478a877fd522c29a96e1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="is-required" :prop="approvalCancel" v-if="base.is_allow_cancel === 1">
          <el-radio-group v-model="base.allow_type">
            <!-- 未审批之前可撤销（无需审批人同意，撤销原因费必填） -->
            <el-radio class="radio" :label="1">{{ $t('work_rule_17') }}</el-radio> <br />
            <!-- 审批流未完成时均可撤销（无需审批人同意，需填写撤销原因） -->
            <el-radio class="radio" :label="2">{{ $t('work_rule_18') }}</el-radio> <br />
            <!-- 审批完成后N天可撤销。（需审批人同意，需填写撤销原因）  -->
            <el-radio class="radio" :label="3">
              {{ $t('work_rule_19') }}
              <el-form-item class="inline" prop="allow_cancel_days">
                <el-input-number
                  class="short-select"
                  v-model="base.allow_cancel_days"
                  controls-position="right"
                  :min="0"
                  :step="1"
                  step-strictly
                  :disabled="base.allow_type !== 3"
                ></el-input-number>
              </el-form-item>
              {{ $t('work_rule_20') }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <Org
      v-if="orgVisible"
      :defaultDepatment="selectedOrg.depart"
      :defaultEmployess="selectedOrg.staff"
      :visible.sync="orgVisible"
      @onConfirm="handleSelectPerson"
      :params="{ is_leave: 1 }"
      :show="{ showType: '1' }"
    />
  </div>
</template>

<script>
import { baseRules } from '../design/rules'
import { logos, logoBgColors } from '../form/enum/icon'
import { getGroup } from 'api/flow'
import Org from '@/components/organization'

export default {
  components: {
    Org
  },
  name: 'Basic',
  props: {
    base: {
      type: Object,
      default: () => {}
    },
    selectData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      logos,
      logoBgColors,
      rules: baseRules(this),
      groups: [],
      orgVisible: false
    }
  },
  computed: {
    // 选中对象回显
    selected() {
      try {
        return [...this.base.visible.staff, ...this.base.visible.department].splice(0, 3)
      } catch (error) {
        return []
      }
    },
    // 选中回显Org组件
    selectedOrg() {
      try {
        const { department, staff } = this.base.visible
        return {
          depart: department.map(item => ({ department_id: item.id, department_name: item.name })),
          staff: staff.map(item => ({ staff_id: item.id, staff_name: item.name }))
        }
      } catch (error) {
        return {}
      }
    },
    // 撤销校验之prop
    approvalCancel: vm => (vm.base.is_allow_cancel === 4 ? 'allow_cancel_days' : 'is_allow_cancel'),
    // 是否展示撤销选项
    isViewCancel: vm => vm.base.is_allow_cancel === 1,
    // 只有新的审批流可修改logo
    isNewFlow: vm => vm.base.type === 2
  },
  created() {
    this.handleGetGroup()
  },
  methods: {
    async handleGetGroup() {
      this.groups = (await getGroup()).data
    },
    // 选择人员 数据回显
    handleSelectPerson({ dept_list, staff_list }) {
      this.base.visible.staff = staff_list.map(item => ({ id: item.staff_id, name: item.staff_name }))
      this.base.visible.department = dept_list.map(item => ({
        id: item.department_id,
        name: item.department_name
      }))
    },
    // 部分人员弹出选人界面
    handlerChangePersonType(value) {
      if (value) this.orgVisible = true
    },
    // 表单校验
    doSubmit() {
      let state
      this.$refs.form.validate(valid => {
        state = valid
      })
      return state
    }
  }
}
</script>
